<template>
  <div>
    <h1 class="title">{{question.topic}}</h1>

    <textarea v-model="selectedAnswer" @change="emitAnswer"></textarea>
  </div>
</template>

<script>
  import {required} from 'vuelidate/lib/validators'
  import {getQuestionnaireAnswer} from '@/api/questionnaire'

  import RpTextbox from 'raypro_ui/src/components/ui/inputs/TextBox'
  import RpButton from 'raypro_ui/src/components/ui/inputs/Button'
  import RpSprite from 'raypro_ui/src/components/ui/Sprite'

  export default {
    name: 'Textbox',

    components: {
      RpButton,
      RpSprite,
      RpTextbox
    },

    mounted() {
      this.checkQuestionStatus()
    },

    props: {question: Object},

    data() {
      return {
        selectedAnswer: '',
        answered: false
      }
    },

    validations: {selectedAnswer: {required}},

    methods: {
      emitAnswer() {
        this.$emit('update', {value: this.selectedAnswer, id: this.question.id})
      },

      checkQuestionStatus() {
        // Check if the question has been answered
        const questionId = this.question.id

        getQuestionnaireAnswer(questionId, this.patientId, this.questionnaireId)
          .then((response) => {
            const hasAnswer = response.data[0].answer.id

            if(hasAnswer) {
              this.$emit('answered', true)

              // Set answered answer
              const value = response.data[0].value
              const answer = response.data[0].answer.options.find((answer) => {
                return answer.value === value
              })

              this.selectedAnswer = answer
            } else {
              this.$emit('answered', false)
            }
          })
          .catch(() => {
          })
      }
    },

    computed: {
      patientId() {
        return this.$route.params.id
      },
      questionnaireId() {
        return this.$route.params.questionnaireId
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'

  textarea
    display: block
    resize: none
    width: 100%
    border: none
    font-family: $font-regular
    font-size: $font-size-input
    background: none
    padding: 13px 10px
    @include placeholder($color-text-light)
    border-radius: 3px
    transition: border-color $transition-duration $transition-easing
    border: 2px solid $color-primary

    &:disabled
      border: 2px solid $color-grey-dark

    &:focus
      outline: none

    color: $color-text

</style>




// WEBPACK FOOTER //
// src/components/pages/Questionnaire/Elements/Textbox.vue